import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"
import { logo, logoDark, logoLightPng } from "helpers/sf_constants"
import AdminUserSidebarContent from "./AdminUserSidebarContent"

const renderSidebarLogo = (themeClass, logoImage) => {
  return (
    <Link to="/" className={`logo ${themeClass}`}>
      <span className="logo-sm">
        <img src={logo} style={{ width: '125%' }} />
      </span>
      <span className="logo-lg">
        <img src={logoImage} style={{ maxWidth: '90%' }} />
      </span>
    </Link>
  );
}

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          {renderSidebarLogo("logo-dark", logoDark)}
          {renderSidebarLogo("logo-light", logoLightPng)}
        </div>
        <div data-simplebar className="h-100">
          {props.isAdminLayout && props.isAdminLayout ?
            <AdminUserSidebarContent adminRolePermissions={props.adminRolePermissions} currentAdminUser={props.currentAdminUser} adminNotifications={props?.adminNotifications} loadings={props.loadings} /> :
            <SidebarContent isPlatformSettingFeatures={props.isPlatformSettingFeatures} rolePermissions={props?.rolePermissions} campaigns={props?.campaigns} loadings={props.loadings} />}
          {/* // {props.type !== "condensed" ? <SidebarContent rolePermissions={props?.rolePermissions} /> : <SidebarContent />} */}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
